import React from "react";

const Java_Scanner_nextLong = () => {
  return (
    <div>
      <h1>Java Scanner nextLong</h1>
      <p>This page provides explanations, examples, and common use-cases for Java Scanner nextLong in Java.</p>
    </div>
  );
};

export default Java_Scanner_nextLong;
